<script setup lang="ts">
interface Props {
  text?: string
  variant?: 'primary' | 'secondary'
  size?: 'small' | 'medium' | 'large'
  fullWidthOnMobile?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  text: 'ОСТАВИТЬ ЗАЯВКУ',
  variant: 'primary',
  size: 'medium',
  fullWidthOnMobile: false,
})

const emit = defineEmits<{
  (e: 'click', event: MouseEvent): void
}>()

const handleClick = (event: MouseEvent) => {
  emit('click', event)
}
</script>

<template>
  <button
    type="button"
    :class="[
      'application-button',
      `application-button--${props.variant}`,
      `application-button--${props.size}`,
      { 'application-button--full-mobile': props.fullWidthOnMobile },
    ]"
    @click="handleClick"
  >
    {{ props.text }}
  </button>
</template>

<style scoped>
.application-button {
  background-color: var(--color-primary);
  color: var(--color-white);
  padding: 0.625rem 1.25rem;
  cursor: pointer;
  transition:
    background-color 0.6s ease,
    color 0.6s ease;
  margin: 0 auto;
  font-family: Montserrat, Arial, sans-serif;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.06rem;
  width: fit-content;
  display: inline-block;
  border: var(--color-primary) 0.188rem solid;
}

.application-button--primary {
  background-color: var(--color-primary);
  color: var(--color-white);
}

.application-button--primary:hover {
  background-color: var(--color-white);
  color: var(--color-primary);
  border: var(--color-primary) 0.188rem solid;
}

.application-button--secondary {
  background-color: var(--color-white);
  color: var(--color-primary);
  border: var(--color-primary) 0.125rem solid;
}

.application-button--secondary:hover {
  background-color: var(--color-primary);
  color: var(--color-white);
}

.application-button--small {
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
}

.application-button--medium {
  padding: 0.625rem 1.25rem;
  font-size: 0.875rem;
}

.application-button--large {
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
}

@media (max-width: 48rem) {
  .application-button.application-button--full-mobile {
    width: 100%;
    margin-top: 2rem;
    height: 2.75rem;
    padding: 0 0.625rem;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.625rem;
    align-self: stretch;
  }
}

@media (hover: none) and (pointer: coarse) {
  .application-button--primary:hover {
    background-color: var(--color-primary);
    color: var(--color-white);
    border: none;
  }

  .application-button--secondary:hover {
    background-color: var(--color-white);
    color: var(--color-primary);
    border: var(--color-primary) 0.125rem solid;
  }
}
</style>
